import script from "./WithdrawStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./WithdrawStudents.vue?vue&type=script&setup=true&lang=js"

import "./WithdrawStudents.vue?vue&type=style&index=0&id=2c8cd592&lang=css"

const __exports__ = script;

export default __exports__